export const MAX_FRAME_SIZE = 800;

export const SQUARE_SHAPE = 'square';
export const PORTRAIT_SHAPE = 'portrait';
export const LANDSCAPE_SHAPE = 'landscape';

export const BACKGROUND_LAYER_TYPE = 'background_layer';
export const PAPER_LAYER_TYPE = 'paper';
export const UYO_PAPER_LAYER_TYPE = 'uyo_paper';
export const STAMP_LAYER_TYPE = 'stamp';
export const LINER_LAYER_TYPE = 'liner';
export const ENVELOPE_PAPER_LAYER_TYPE = 'envelope_paper';
export const PHOTO_MASK_LAYER_TYPE = 'photo_mask';
export const PHOTO_LAYER_TYPE = 'photo';
export const TEXT_LAYER_TYPE = 'text';
export const STICKER_LAYER_TYPE = 'sticker';

export const SCENARIO_IDS = ['media', 'card', 'envelope'];
export const SCENE_IDS = [
  'cardFront',
  'cardBack',
  'envelopeBackFlap',
  'envelopeBackBase',
  'envelopeFrontFlap',
];

export const DIMENSIONS_PER_SHAPE = {
  [SQUARE_SHAPE]: {
    height: 1575,
    width: 1575,
  },
  [LANDSCAPE_SHAPE]: {
    height: 1500,
    width: 2100,
  },
  [PORTRAIT_SHAPE]: {
    height: 2100,
    width: 1500,
  },
};

export const CARD_TEMPLATE_VARIABLES_PER_SHAPE = {
  [SQUARE_SHAPE]: {
    showCardCardX: { portrait: 0, landscape: -14, square: 0 },
    showCardCardY: { portrait: 0, landscape: 0, square: 0 },
    showCardCardScale: { portrait: 0.82, landscape: 0.76, square: 0.8 },
    showCardEnvelopeX: { portrait: 40, landscape: 32, square: 58 },
    showCardEnvelopeY: { portrait: -3, landscape: 11, square: 10 },
    showCardEnvelopeScale: { portrait: 1.2, landscape: 1.1, square: 1.1 },

    showEnvelopeBackCardX: { portrait: 37, landscape: 14, square: 30 },
    showEnvelopeBackCardY: { portrait: -3, landscape: -6, square: -5 },
    showEnvelopeBackCardScale: { portrait: 0.75, landscape: 0.76, square: 0.8 },
    showEnvelopeBackEnvelopeX: { portrait: 0, landscape: -32, square: 0 },
    showEnvelopeBackEnvelopeY: { portrait: -4, landscape: 12, square: 13 },
    showEnvelopeEnvelopeScale: { portrait: 1.2, landscape: 1.1, square: 1.2 },

    showEnvelopeFrontCardX: { portrait: 37, landscape: 14, square: 30 },
    showEnvelopeFrontCardY: { portrait: -3, landscape: -6, square: -5 },
    showEnvelopeFrontCardScale: { portrait: 0.75, landscape: 0.76, square: 0.8 },
    showEnvelopeFrontEnvelopeX: { portrait: 0, landscape: -21, square: 0 },
    showEnvelopeFrontEnvelopeY: { portrait: -16, landscape: -28, square: -28 },
    showEnvelopeFrontEnvelopeScale: { portrait: 1.2, landscape: 1.3, square: 1.35 },

    envelopeShape: SQUARE_SHAPE,
    envelopeWidthRatio: 0.596,
    envelopeHeightRatio: 1,
    envelopeFlapY: 0.4055,
    envelopeHoleY: 0.85,
    envelopeLogoR: 0.71,
    envelopeLogoX: 0.12,
    envelopeLogoY: 0.5,
    envelopeFrontBaseTextPosition: [0.5, 0.71],
    cardWidthRatio: 0.9,
    cardHeightRatio: 0.9,

    introEnvelopeCardScale: 0.55,
    introEnvelopeCardRotation: 0,
    introEnvelopeCardX: 0,
    introEnvelopeCardY: 21,
    introEnvelopeCardScaleEnd: 0.75,
    introEnvelopeCardXEnd: 0,
    introEnvelopeCardYEnd: -47.1,

    introCardScale: 0.9,
    introEnvelopeScale: 1.2,
    introEnvelopeScaleEnd: 1.2,
    introEnvelopeY: -28,
    introEnvelopeYEnd: 56.5,
  },
  [PORTRAIT_SHAPE]: {
    showCardCardX: { portrait: 0, landscape: -19, square: 0 },
    showCardCardY: { portrait: 0, landscape: 0, square: 0 },
    showCardCardScale: { portrait: 1.2, landscape: 0.8, square: 0.85 },
    showCardEnvelopeX: { portrait: 21, landscape: 21, square: 34 },
    showCardEnvelopeY: { portrait: -6, landscape: -5.25, square: -6.5 },
    showCardEnvelopeScale: { portrait: 1.15, landscape: 0.78, square: 0.83 },

    showEnvelopeBackCardX: { portrait: 60, landscape: 20, square: 35 },
    showEnvelopeBackCardY: { portrait: -3, landscape: 0, square: 0 },
    showEnvelopeBackCardScale: { portrait: 1.2, landscape: 0.8, square: 0.9 },
    showEnvelopeBackEnvelopeX: { portrait: 0, landscape: -20, square: 0 },
    showEnvelopeBackEnvelopeY: { portrait: -3, landscape: 3, square: 0 },
    showEnvelopeEnvelopeScale: { portrait: 1.15, landscape: 0.84, square: 0.9 },

    showEnvelopeFrontCardX: { portrait: 60, landscape: 28, square: 35 },
    showEnvelopeFrontCardY: { portrait: -3, landscape: 0, square: 0 },
    showEnvelopeFrontCardScale: { portrait: 1.2, landscape: 0.8, square: 0.9 },
    showEnvelopeFrontEnvelopeX: { portrait: 0, landscape: -9, square: 0 },
    showEnvelopeFrontEnvelopeY: { portrait: -27, landscape: -29, square: -24 },
    showEnvelopeFrontEnvelopeScale: { portrait: 1.15, landscape: 1.2, square: 1 },

    envelopeShape: LANDSCAPE_SHAPE,
    envelopeWidthRatio: 0.713,
    envelopeHeightRatio: 1,
    envelopeFlapY: 0.48766,
    envelopeHoleY: 0.95,
    envelopeLogoR: 0.71,
    envelopeLogoX: 0.12,
    envelopeLogoY: 0.54,
    envelopeFrontBaseTextPosition: [0.5, 0.75],
    cardWidthRatio: 0.713,
    cardHeightRatio: 1,

    introEnvelopeCardScale: 0.68,
    introEnvelopeCardRotation: -90,
    introEnvelopeCardX: 0,
    introEnvelopeCardY: 24,
    introEnvelopeCardScaleEnd: { portrait: 0.685, landscape: 0.643, square: 0.643 },
    introEnvelopeCardXEnd: { portrait: 0, landscape: 0, square: 0 },
    introEnvelopeCardYEnd: { portrait: -41.67, landscape: -45, square: -45 },

    introCardScale: { portrait: 1.2, landscape: 0.9, square: 0.9 },
    introEnvelopeScale: 1.2,
    introEnvelopeScaleEnd: { portrait: 1.75, landscape: 1.4, square: 1.4 },
    introEnvelopeY: { portrait: -28, landscape: -28, square: -28 },
    introEnvelopeYEnd: { portrait: 73, landscape: 63, square: 63 },
  },
  [LANDSCAPE_SHAPE]: {
    showCardCardX: { portrait: 0.5, landscape: -15, square: 0 },
    showCardCardY: { portrait: 0, landscape: 5, square: 0 },
    showCardCardScale: { portrait: 0.88, landscape: 0.75, square: 0.84 },
    showCardEnvelopeX: { portrait: 35, landscape: 35, square: 33 },
    showCardEnvelopeY: { portrait: -7, landscape: 0, square: -6 },
    showCardEnvelopeScale: { portrait: 1, landscape: 0.8, square: 0.84 },

    showEnvelopeBackCardX: { portrait: 33, landscape: 10, square: 30 },
    showEnvelopeBackCardY: { portrait: 10, landscape: 0, square: -5 },
    showEnvelopeBackCardScale: { portrait: 0.88, landscape: 0.78, square: 0.8 },
    showEnvelopeBackEnvelopeX: { portrait: 0, landscape: -22, square: 0 },
    showEnvelopeBackEnvelopeY: { portrait: -3, landscape: 0, square: -4 },
    showEnvelopeEnvelopeScale: { portrait: 1.15, landscape: 0.9, square: 0.88 },

    showEnvelopeFrontCardX: { portrait: 33, landscape: 10, square: 30 },
    showEnvelopeFrontCardY: { portrait: -10, landscape: 0, square: -5 },
    showEnvelopeFrontCardScale: { portrait: 0.82, landscape: 0.78, square: 0.8 },
    showEnvelopeFrontEnvelopeX: { portrait: 3, landscape: -10, square: 0 },
    showEnvelopeFrontEnvelopeY: { portrait: -23, landscape: -20, square: -23 },
    showEnvelopeFrontEnvelopeScale: { portrait: 1.15, landscape: 1.1, square: 1.03 },

    envelopeShape: LANDSCAPE_SHAPE,
    envelopeWidthRatio: 0.713,
    envelopeHeightRatio: 1,
    envelopeFlapY: 0.48766,
    envelopeHoleY: 0.95,
    envelopeLogoR: 0.71,
    envelopeLogoX: 0.12,
    envelopeLogoY: 0.54,
    envelopeFrontBaseTextPosition: [0.5, 0.75],
    cardWidthRatio: 1,
    cardHeightRatio: 0.713,

    introEnvelopeCardScale: 0.68,
    introEnvelopeCardRotation: 0,
    introEnvelopeCardX: 0,
    introEnvelopeCardY: 24,
    introEnvelopeCardScaleEnd: 0.75,
    introEnvelopeCardXEnd: 0,
    introEnvelopeCardYEnd: -33.3,

    introCardScale: 0.9,
    introEnvelopeScale: 1.2,
    introEnvelopeScaleEnd: 1.2,
    introEnvelopeY: -28,
    introEnvelopeYEnd: 40,
  },
};

export const SQUARE_ASPECT_RANGE = [0.78, 1.22];

export const viewportTypeForAspectRatio = (aspectRatio) => {
  switch (true) {
    case aspectRatio < SQUARE_ASPECT_RANGE[0]:
      return 'portrait';
    case aspectRatio > SQUARE_ASPECT_RANGE[1]:
      return 'landscape';
    default:
      return 'square';
  }
};
